import React, { ChangeEventHandler, FC } from 'react';
import { CircularProgress, InputBaseComponentProps, ThemeProvider } from '@material-ui/core';
import { theme } from '../theme/mui-theme';
import { StyledContainer, StyledIcon, StyledInput } from './SearchBox.styled';

interface Props {
	readonly name: string;
	readonly searchKeyword: string;
	readonly onSearch: ChangeEventHandler<HTMLInputElement>;
	readonly placeholder?: string;
	readonly loading?: boolean;
}

const SearchBox : FC<Props> = ({ name, searchKeyword, onSearch, placeholder = 'Search', loading = false }) => {
	const inputProps : InputBaseComponentProps = {
		'aria-label': 'search',
	};

	return (
		<ThemeProvider theme={theme}>
			<StyledContainer>
				{ loading ? <CircularProgress size="24px" /> : <StyledIcon /> }

				<StyledInput
					name={name}
					placeholder={placeholder}
					inputProps={inputProps}
					value={searchKeyword}
					onChange={onSearch}
					autoComplete="off"
				/>
			</StyledContainer>
		</ThemeProvider>
	);
};

export default SearchBox;
